/**
 * =====================================================================
 * ASSETS TAB - Asset Management (CRUD Operations)
 * =====================================================================
 *
 * This is extracted from the original FixedAssets.tsx page.
 * For now, it imports and wraps the existing FixedAssets component.
 * In the future, this can be refactored to a pure component.
 *
 * =====================================================================
 */

import React from 'react'
import { AdminUser } from '@/lib/authService'
import FixedAssets from '@/pages/finance/FixedAssets'

interface AssetsTabProps {
  user: AdminUser | null
  refreshTrigger: number
  onDataChange: () => void
}

export default function AssetsTab({ user, refreshTrigger, onDataChange }: AssetsTabProps) {
  // For now, we'll render the existing FixedAssets component
  // The header is already in the parent unified page, so we might want to hide it
  return <FixedAssets user={user} />
}
